import { render } from "./TecladoVirtual.vue?vue&type=template&id=da5b607e&scoped=true"
import script from "./TecladoVirtual.vue?vue&type=script&lang=js"
export * from "./TecladoVirtual.vue?vue&type=script&lang=js"

import "./TecladoVirtual.vue?vue&type=style&index=0&id=da5b607e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da5b607e"]])

export default __exports__